import Model, { attr, belongsTo } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

import type Flow from './flow';
import type Questionnaire from './questionnaire';

export default class FlowQuestionnaire extends Model {
  declare [Type]: 'flow-questionnaire';

  @belongsTo('flow', { async: false, inverse: 'flowQuestionnaires' })
  declare flow: Flow;

  @belongsTo('questionnaire', { async: false, inverse: null })
  declare questionnaire: Questionnaire;

  @attr('number') declare position: number;
}
